import Highcharts from 'highcharts/highstock';
import mapFactory from 'highcharts/modules/map';
import {DRILLDOWN} from '../constants';
import {AppConf} from "../AppConf";

mapFactory(Highcharts);

global.Highcharts = Highcharts;

const moment = window.moment;

Highcharts.setOptions({

    global : {
        useUTC : false,
        getTimezoneOffset: function (timestamp) {
            var zone = 'Europe/Rome',
                timezoneOffset = -moment.tz(timestamp, zone).utcOffset();
            return timezoneOffset;
        }
    },
    colors : [ '#4572A7', '#89A54E', '#AA4643', '#80699B',
        '#3D96AE', '#DB843D', '#92A8CD', '#A47D7C',
        '#EFDA64', '#6699CC', '#B5CA92', '#B45956',
        '#BFB3CD', '#98D1E1', '#E6A671', '#E0B5B4',
        '#F6E4B2','#9FCB9F', '#AE70AC' ],

});

export const initialGrow = 1534957;

function hourFormatter(value) {
    return Highcharts.dateFormat('%H', value);
};

function dayFormatter(value) {
    return Highcharts.dateFormat('%a, %e %b', value);
};


function monthFormatter(value) {
    return Highcharts.dateFormat('%b %Y', value);
};


export const dateUtil = [
    null,
    {year:'numeric'},
    { month:'long'},
    {day:'numeric', weekday:'long'},
    {hour:'numeric', minute:'numeric'}
];


export const dateInfo = [
    {year:'numeric'},
    {year:'numeric', month:'long'},
    {month:'long', day:'numeric', weekday:'short'},
    {hour:'numeric', minute:'numeric'}
];


export const GROWTH = {
    title: {
        text: null
    },
    chart: {
        zoomType: 'x',
        defaultSeriesType: 'areaspline',
        marginRight: 80,
        marginLeft: 100,
        marginTop: 40,
        height: 450,
    },
    tooltip : {
        shared: false,
    },
    legend: {
        enabled: true
    },
    plotOptions: {
        areaspline: {
            events: {
                legendItemClick: function () {
                    return false;
                }
            },
            fillColor: {
                linearGradient: {
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 1
                },
                stops: [
                    [0, Highcharts.getOptions().colors[0]],
                    [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
                ]
            },
            marker: {
                enabled: false,
                radius: 1
            },
            lineWidth: 1,
            states: {
                hover: {
                    lineWidth: 1
                }
            },
            threshold: null
        },
        spline: {
            events: {
                legendItemClick: function () {
                    return false;
                }
            },
            marker: {
                enabled: true
            },
            lineWidth: 1,
            states: {
                hover: {
                    lineWidth: 1
                }
            },
        }
    },
    yAxis: [{
        title: {
            text: "Numero Domini Registrati",
            style: {
                color: Highcharts.getOptions().colors[0]
            }
        },
        labels: {
            style: {
                color: Highcharts.getOptions().colors[0]
            }
        }
    },
        {
            title: {
                text: "Tasso di Crescita Annuale",
                style: {
                    color: Highcharts.getOptions().colors[2]
                },
            },
            labels: {
                format: '{value}%',
                style: {
                    color: Highcharts.getOptions().colors[2]
                }
            },
            opposite: true
        }
    ],
    xAxis: {
        minRange: 6 * 30 * 3600 * 24 * 1000,
        gridLineWidth: 1,
        crosshair: true,
        type: 'datetime',
    },
    series: []
};

export const REGISTRAR_GROWTH = {

    chart: {

        defaultSeriesType: 'spline',

    },
    title: {
        text: "Tasso di crescita registrar divisi per zona"
    },
    plotOptions: {

        series: {
            cursor: 'default'
        },
        spline: {
            marker: {
                radius: 2
            },
            lineWidth: 2,
            states: {
                hover: {
                    lineWidth: 1
                }
            },
        }
    },
    xAxis: {
        minRange: 6 * 30 * 3600 * 24 * 1000,
        gridLineWidth: 1,
        crosshair: true
    },
    yAxis: {
        min: null,
        title: {
            text:"tasso crescita"
        },
        labels: {
            format: '{value}%',
        }
    }
};

// Nuove---

export const defaultGraphOptions = {
    title: {
        title:null
    },
    exporting: {
        enabled: false
    },
    chart : {
        defaultSeriesType : 'column',
        height: 420,
        marginRight : 20,
        marginLeft : 100,
        marginTop : 40
    },
    legend : {
        enabled : true
    },
    credits : {
        enabled: false,
        text: "Registro.it",
        href: "http://www.nic.it"
    },
    xAxis : {
        type: 'datetime'
    },
    yAxis : {
        title : {
            text : "domini"
        }
    },
    tooltip : {
        shared: true
    },
    plotOptions : {
        column : {
            point : {
                events : {}
            },
            dataLabels : {			}
        },
        spline : {
            point : {
                events : {}
            }
        },
    },
    series : []
};

export const defaultStackOptions = {
    yAxis : {
        stackLabels : {
            enabled : true,
            style : {
                fontWeight : 'bold',
                color : (Highcharts.theme && Highcharts.theme.textColor)
                || 'gray'
            },
            formatter : function() {
                return Highcharts.numberFormat(this.total, 0);
            }
        }
    },
    tooltip : {
        pointFormatter: function() {
            return pointWithPercentage(this);
        },
        footerFormat: "Tot: <b>{point.total:,.0f}</b>"
    },
    plotOptions : {
        series: {
            cursor: 'pointer'
        },
        column : {
            stacking : 'normal'
        }
    }
};

// ----



export var periodGraphOptions = {
    yearly : {
        title : {
            text : null
        },
        xAxis : {
        }
    },

    monthly : {
        title : {
            text : null
        },
        xAxis : {
            labels: {
                formatter : function() {
                    return monthFormatter(this.value);
                },
                rotation : -45,
                align : 'right',
                style : {
                    font : 'normal 10px Lato, sans-serif'
                }
            }
        }
    },
    daily : {
        title : {
            text : null
        },
        xAxis : {
            tickInterval: 24 * 3600 * 1000,
            labels : {
                formatter : function() {
                    return dayFormatter(this.value);
                },
                rotation : -45,
                align : 'right',
                style : {
                    font : 'normal 10px Lato, sans-serif'
                }
            }
        },
        yAxis : {
            stackLabels : {
                rotation : 0,
                y : -10,
                align : 'center'
            }
        }
    },
    hourly : {
        title : {
            text : null
        },
        xAxis : {
            tickInterval: 3600 * 1000,
            labels : {
                formatter : function() {
                    return hourFormatter(this.value);
                }
            }
        },
        yAxis : {
            stackLabels : {
                rotation : 0,
                y : -10,
                align : 'center'
            }
        }
    }
};



function pointWithPercentage(point) {
    return  '<span style="color:' + point.series.color+ '">\u25CF</span> ' + point.series.name + ': <b>' +  Highcharts.numberFormat(point.y, 0) + ' (' + Highcharts.numberFormat(point.percentage, 1) +'%)</b><br/>';
}


export var rootURL = AppConf.getPublicRootUrl();

export var urlsConfiguration = {
    domain: {
        base: 'domain',

        operations: {
            'growth': {
                clickable:false,
                dataDetails:false,
                maxDrillDown:0,
                description: true,
                paths:[
                    {url:'sync/registration/monthly', param:'start=2007-12-01&ts=true'},
                    {url:'async/registration/monthly',param:'start=2007-12-01&ts=true'},
                    {url:'sync/delete/monthly',param:'start=2007-12-01&ts=true'},
                    {url:'async/delete/monthly',param:'start=2007-12-01&ts=true'},
                    {url:'sync/registration/monthly', param:'start=2007-12-01&edu=only&ts=true'},
                    {url:'sync/delete/monthly',param:'start=2007-12-01&edu=only&ts=true'},

                ]
            },

            'restore': {
                clickable: true,
                maxDrillDown:2,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[2]},
                paths:[
                    {param:'idn=no&edu=no',url:'sync/restore',key:'DOMAINS', color:Highcharts.getOptions().colors[0], merge: true},
                    {param:'', url:'async/restore', key:'ASYNC', color:Highcharts.getOptions().colors[3], merge: true},
                    {param:'idn=only&edu=no', url:'sync/restore', key:'DOMAINS.IDN', color:Highcharts.getOptions().colors[2]},
                    {param:'idn=no&edu=only',url:'sync/restore',key:'EDU.IT', color:Highcharts.getOptions().colors[1],},
                    {param:'idn=only&edu=only',url:'sync/restore',key:'EDU.IDN.IT', color:Highcharts.getOptions().colors[4],}

                ]
            },

            'reassign': {
                clickable: true,
                maxDrillDown:1,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[1]},
                paths:[
                    {param:'idn=no&edu=no',url:'sync/reassign',key:'DOMAINS', color:Highcharts.getOptions().colors[0], merge: true},
                    {param:'', url:'async/reassign', key:'DOMAINS.IDN', color:Highcharts.getOptions().colors[3], merge: true},
                    {param:'idn=only&edu=no', url:'sync/reassign', key:'IDN', color:Highcharts.getOptions().colors[2]},
                    {param:'idn=no&edu=only',url:'sync/reassign',key:'EDU.IT', color:Highcharts.getOptions().colors[1],},
                    {param:'idn=only&edu=only',url:'sync/reassign',key:'EDU.IDN.IT', color:Highcharts.getOptions().colors[4],}

                ]
            },

            'registration':{
                clickable:true,
                maxDrillDown:3,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[3]},
                paths:[
                    {param:'idn=no&edu=no', url:'sync/registration', key:'DOMAINS', color:Highcharts.getOptions().colors[0], merge: true},
                    {param:'', url:'async/registration',key:'DOMAINS.IDN', color:Highcharts.getOptions().colors[3], merge: true},
                    {param:'idn=only&edu=no',url:'sync/registration',key:'IDN', color:Highcharts.getOptions().colors[2],},
                    {param:'idn=no&edu=only',url:'sync/registration',key:'EDU.IT', color:Highcharts.getOptions().colors[1],},
                    {param:'idn=only&edu=only',url:'sync/registration',key:'EDU.IDN.IT', color:Highcharts.getOptions().colors[4],}

                ],
            },

            'renewal': {
                clickable: true,
                maxDrillDown:2,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[2]},
                paths:[
                    {param:'idn=no&edu=no',url:'sync/renewal', key:'DOMAINS', color:Highcharts.getOptions().colors[0], merge: true},
                    {param:'', url:'async/renewal', key:'DOMAINS.IDN', color:Highcharts.getOptions().colors[3], merge: true},
                   {param:'idn=only&edu=no', url:'sync/renewal',key:'IDN', color:Highcharts.getOptions().colors[2]},
                    {param:'idn=no&edu=only',url:'sync/renewal',key:'EDU.IT', color:Highcharts.getOptions().colors[1],},
                    {param:'idn=only&edu=only',url:'sync/renewal',key:'EDU.IDN.IT', color:Highcharts.getOptions().colors[4],}

                ]
            },

            'delete': {
                clickable: true,
                maxDrillDown:3,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[3]},
                paths:[
                    {param:'idn=no&edu=no', url:'sync/delete', key:'DOMAINS', color:Highcharts.getOptions().colors[0], merge: true},
                    {param:'', url:'async/delete', key:'DOMAINS.IDN', color:Highcharts.getOptions().colors[3], merge: true},
                    {param:'idn=only&edu=no', url:'sync/delete',key:'IDN', color:Highcharts.getOptions().colors[2]},
                    {param:'idn=no&edu=only',url:'sync/delete',key:'EDU.IT', color:Highcharts.getOptions().colors[1],},
                    {param:'idn=only&edu=only',url:'sync/delete',key:'EDU.IDN.IT', color:Highcharts.getOptions().colors[4],}

                ]
            },

            'transfer': {
                clickable: true,
                maxDrillDown:2,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[2]},
                paths:[
                    {param:'idn=no&edu=no', url:'sync/transfer', key:'DOMAINS', color:Highcharts.getOptions().colors[0], merge: true},
                    {param:'', url:'async/transfer', key:'DOMAINS.IDN', color:Highcharts.getOptions().colors[3], merge: true},
                    {param:'idn=only&edu=no', url:'sync/transfer', key:'IDN', color:Highcharts.getOptions().colors[2]},
                    {param:'idn=no&edu=only',url:'sync/transfer',key:'EDU.IT', color:Highcharts.getOptions().colors[1],},
                    {param:'idn=only&edu=only',url:'sync/transfer',key:'EDU.IDN.IT', color:Highcharts.getOptions().colors[4],}

                ]
            },
            'transferWithTrade':{
                clickable:true,
                maxDrillDown:2,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[2]},
                paths:[
                    {param:'idn=no&edu=no', url:'sync/transferTrade', key:'DOMAINS', color:Highcharts.getOptions().colors[0], merge: true},
                    {param:'', url:'async/transferTrade', key:'DOMAINS.IDN', color:Highcharts.getOptions().colors[3], merge: true},
                    {param:'idn=only&edu=no', url:'sync/transferTrade', key:'IDN', color:Highcharts.getOptions().colors[2]},
                    {param:'idn=no&edu=only',url:'sync/transferTrade',key:'EDU.IT', color:Highcharts.getOptions().colors[1],},
                    {param:'idn=only&edu=only',url:'sync/transferTrade',key:'EDU.IDN.IT', color:Highcharts.getOptions().colors[4],}

                ]
            },

            'transferBulk':{
                clickable:true,
                maxDrillDown:2,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[2]},
                paths:[
                    {param:'idn=no&edu=no', url:'sync/transferBulk', key:'DOMAINS', color:Highcharts.getOptions().colors[0]},
                    {param:'idn=only&edu=no', url:'sync/transferBulk', key:'DOMAINS.IDN', color:Highcharts.getOptions().colors[2]},
                    {param:'idn=no&edu=only',url:'sync/transferBulk',key:'EDU.IT', color:Highcharts.getOptions().colors[1],},
                    {param:'idn=only&edu=only',url:'sync/transferBulk',key:'EDU.IDN.IT', color:Highcharts.getOptions().colors[4],}

                ]
            },

            'transferTotal':{
                clickable:true,
                maxDrillDown:2,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[2]},
                paths:[
                    {param:'idn=no&edu=no', url:'sync/transferTotal', key:'DOMAINS', color:Highcharts.getOptions().colors[0], merge: true},
                    {param:'', url:'async/transferTotal', key:'DOMAINS.IDN', color:Highcharts.getOptions().colors[3], merge: true},
                    {param:'idn=only&edu=no', url:'sync/transferTotal', key:'IDN', color:Highcharts.getOptions().colors[2]},
                    {param:'idn=no&edu=only',url:'sync/transferTotal',key:'EDU.IT', color:Highcharts.getOptions().colors[1],},
                    {param:'idn=only&edu=only',url:'sync/transferTotal',key:'EDU.IDN.IT', color:Highcharts.getOptions().colors[4],}

                ]
            },
        }
    },
    registrant: {
        base:'domain',
        operations: {
            'registration': {
                clickable:true,
                maxDrillDown:3,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[3]},
                paths:[
                    {url:'sync/registration', param:'start=2012-01-01'}
                ]
            },
            'delete': {
                clickable:true,
                maxDrillDown:3,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[3]},
                paths:[
                    {url:'sync/delete', param:'start=2012-01-01'}
                ]
            },
            'restore': {
                clickable:true,
                maxDrillDown:3,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[3]},
                paths:[
                    {url:'sync/restore', param:'start=2012-01-01'}
                ]
            },
            'renewal': {
                clickable:true,
                maxDrillDown:3,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[2]},
                paths:[
                    {url:'sync/renewal', param:'start=2012-01-01'}
                ]
            },
            'transfer': {
                clickable:true,
                maxDrillDown:3,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[3]},
                paths: [
                    {url:'sync/transfer', param:'start=2012-01-01'}
                ]
            },
            'transferWithTrade': {
                clickable:true,
                maxDrillDown:3,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[3]},
                paths: [
                    {url:'sync/transferTrade', param:'start=2012-01-01'}
                ]
            },
            'transferTotal': {
                clickable:true,
                maxDrillDown:3,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[3]},
                paths: [
                    {url:'sync/transferTotal', param:'start=2012-01-01'}
                ]
            }
        }
    },
    registrar: {
        base:'registrar',
        operations: {
            'count': {
                clickable:false,
                selection:false,
                dataDetails:true,
                maxDrillDown:1,
                description: true,

                paths:[
                    {url:'count/monthly', param:'start=2012-01-01'}
                ]
            },
            'delete': {
                //base:'domain', // Override
                clickable:true,
                selection:false,
                maxDrillDown:1,
                dataDetails:true,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[1]},
                paths: [
                    {param:'start=2012-01-01', url:'delete',key:''},
                    //{param:'start=2012-01-01', url:'async/delete',key:''}
                ]
            },
            'domain': {
                clickable:false,
                selection:false,
                dataDetails:true,
                description: true,
                maxDrillDown:1,
                paths:[
                    {url:'domain/monthly', param:'start=2012-01-01'}
                ]
            },
            'registration': {
                clickable:true,
                maxDrillDown:1,
                selection:false,
                dataDetails:true,
                description: true,
                descriptionValues: {drillDownMax:DRILLDOWN[1]},
                paths:[
                    {url:'registration', param:''}
                ]
            },
            'transfer_in': {
                clickable:true,
                maxDrillDown:1,
                selection:false,
                description: true,

                descriptionValues: {drillDownMax:DRILLDOWN[1]},
                dataDetails:true,
                paths:[
                    {url: 'transfer_in', param:''}
                ]
            },
            'transfer_out': {
                clickable:true,
                maxDrillDown:1,
                selection:false,
                dataDetails:true,
                description: true,
                paths:[
                    {url: 'transfer_out', param:''}
                ]
            },

            'contract_transfer_out': {
                clickable:false,
                maxDrillDown:0,
                selection:false,
                dataDetails:true,
                description: true,
                paths:[
                    {url: 'contract_transfer_out/yearly', param:''}
                ]
            },
            'contract_transfer_in': {
                clickable:false,
                maxDrillDown:0,
                selection:false,
                dataDetails:true,
                description: true,
                paths:[
                    {url: 'contract_transfer_in/yearly', param:''}
                ]
            },

            'growth': {
                clickable:false,
                maxDrillDown:1,
                selection:false,
                dataDetails:true,
                description: true,
                paths: [
                    {url:'domain/monthly', param:'start=2012-01-01'}
                ]
            }

        }
    }
};



// WEBPACK FOOTER //
// ./src/library/index.js